<template>
  <layout titlePage=" " :route="{ name: 'carteira' }">
    <section class="c-successful-message">
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column">
          <div class="c-receipt__wrapper has-text-centered">
            <div class="c-successful-message__content">
              <img
                class="c-successful-message__content--img"
                :src="imageSelected"
              />
              <p
                class="c-successful-message__content--title"
                :class="{
                  'error--title': this.error,
                  'success--title': this.success,
                }"
              >
                {{ message }}
              </p>

              <p class="c-successful-message__content--subtitle">
                {{ subtitle }}
              </p>
              <p v-if="showButton">
                <button
                  v-clipboard:copy="code"
                  v-clipboard:success="copiedSuccess"
                  type="button"
                  class="button is-big is-support"
                >
                  Copiar código de pagamento PIX
                </button>
              </p>
              <p v-if="!error && this.success">
                Você já pode fechar essa guia ;)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'

import copied from '@/assets/img/copied.png'
import pixBrand from '@/assets/img/pix.svg'
import errorCopied from '@/assets/img/error-copied.png'

export default {
  components: {
    layout,
  },

  data() {
    return {
      copied,
      errorCopied,
      pixBrand,
      imageSelected: pixBrand,
      code: '',
      showButton: false,
      message: 'Código copiado com sucesso!',
      subtitle:
        'Agora é só acessar a opção "PIX" no seu Internet Banking ou aplicativo de pagamentos e prosseguir com o pagamento do seu presente.',
      error: false,
      success: false,
    }
  },

  created() {
    const brCode = new URLSearchParams(window.location.search)
    this.code = brCode.get('brCode')
  },

  async mounted() {
    const prefixInvoice =
      '00020101021226790014br.gov.bcb.pix2557invoice.starkbank.com/v2/'
    const prefixBrCode =
      '00020101021226790014br.gov.bcb.pix2557brcode.starkinfra.com/v2/'
    const specificSection = '5204000053039865802BR5925Casar.Com'

    const startsWithPrefix =
      this.code.startsWith(prefixInvoice) || this.code.startsWith(prefixBrCode)

    if (startsWithPrefix && this.code.includes(specificSection)) {
      const textCopied = await navigator.clipboard
        .writeText(this.code)
        .then(
          function () {
            return true
          },
          function () {
            return false
          }
        )
        .catch(function (error) {
          this.setInternalError(error)
          return false
        })

      if (!textCopied) this.copiedInitialState()
      else this.copiedSuccess()
    } else {
      this.setInternalError('Validation error')
    }
  },
  methods: {
    copiedInitialState() {
      this.message = 'Clique no botão abaixo para copiar o código PIX'
      this.subtitle =
        'Use o código copiado no app do seu banco para concluir o pagamento.'
      this.showButton = true
      this.success = false
      this.imageSelected = this.pixBrand
    },

    copiedSuccess() {
      this.message = 'Código copiado com sucesso!'
      this.subtitle =
        'Agora é só acessar a opção "PIX" no seu Internet Banking ou aplicativo de pagamentos e prosseguir com o pagamento do seu presente.'
      this.error = false
      this.success = true
      this.showButton = false
      this.imageSelected = this.copied
    },

    setInternalError(error) {
      console.error(error)
      this.message = 'O código “Copia e Cola” está inválido'
      this.subtitle =
        'Por favor, abra novamente o e-mail que recebeu e clique em “Copiar código PIX”.'
      this.error = true
      this.success = false
      this.imageSelected = this.errorCopied
    },
  },
}
</script>

<style lang="scss">
.c-successful-message {
  &__content {
    &--img {
      max-width: 78px;
      padding-bottom: 25px;
    }

    &--title {
      font-size: 21px;
      font-weight: bold;
      color: #404951;
      padding-bottom: 30px;
    }

    &--subtitle {
      padding-bottom: 30px;
    }
  }
}

.success--title {
  color: #3dafb0;
}

.error--title {
  font-size: 19px;
  color: $error;
}
</style>
